import { useContext } from 'react';
import ModalContext from './ModalContext.js';
import useModalContextImpl from './useModalContextImpl.js';

/**
 * Gestisce il contesto delle modali passando lo stato di show.
 */
function useModalContext(open = false, options, callback) {
    const context = useContext(ModalContext);
    useModalContextImpl(context, ModalContext, open, options, callback);
}

export { useModalContext as default };
